export const data = {


    scene: '03_sauvojenTsekkaus',
    kysymysteksti: 'Ensimmäiseksi tarkista, että sauvat ovat ehjät ja käyttökunnossa.',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'A Sauvat eivät ole käyttökunnossa',
            valinta: 'A sauvoissa fiksattavaa',
            ohjaajan_palaute: 'Hienoa, huomasit toisessa sauvassa haljenneen kumitupen - se pitää vaihtaa',
            koontiteksti: '',
            pisteet: 1,
            arviointitiedosto: 'scene_03_A_huomasi_kumitupen',
            harjoiteltava: [],
            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Opiskelija ohjaa apuvälineiden ja hyvinvointia tukevan teknologian käytössä ja huollossa',
                    osaamistaso: 5,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'ohjaa monipuolisesti apuvälineiden käytössä ja huollossa ja ehkäisee toiminnallaan laitteisiin liittyvien vaaratilanteiden syntymistä',
                            toteutui: 'kyllä'
                        },
                        {
                            kriteeri: 'ohjaa ja käyttää asiakkaan liikkumisen ja siirtymisen apuvälineitä turvallisesti',
                            toteutui: 'kyllä'
                        }
                    ]
                }
            ]
        },


        {

            id: 2,
            teksti: 'B Sauvat ovat käyttökunnossa',
            valinta: 'B sauvat ok',
            ohjaajan_palaute: 'katsoitko varmasti tarpeeksi tarkasti? ',
            koontiteksti: '',
            pisteet: 0,
            arviointitiedosto: 'scene_03_B_ei_huomannut_kumituppea',
            harjoiteltava: [],

            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Opiskelija ohjaa apuvälineiden ja hyvinvointia tukevan teknologian käytössä ja huollossa',
                    osaamistaso: 0,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'ohjaa ja käyttää asiakkaan liikkumisen ja siirtymisen apuvälineitä turvallisesti',
                            toteutui: 'ei'
                        }
                    ]
                }
            ]

        }
    ]


};